import { render } from "./isCard.vue?vue&type=template&id=7cd67394&scoped=true"
import script from "./isCard.vue?vue&type=script&lang=js"
export * from "./isCard.vue?vue&type=script&lang=js"

import "./isCard.vue?vue&type=style&index=0&id=7cd67394&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd67394"]])

export default __exports__